module.exports = __webpack_public_path__ + "static/media/time-back.0c89c7e2.svg";